import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box } from '@lightspeed/flame/Core';
import { Modal } from '@lightspeed/flame/Modal';

export const HidingBox = styled(Box)`
  display: none;
  @media (min-width: 1400px) {
    display: block;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template: 'container';

  > * {
    grid-area: container;
  }
`;

// We must remake the styling for the flame buttons as the specificity for buttons
// in the reports page is higher than the flame styles
export const FlameButton = styled(Button)`
  &&& {
    color: #020203;
    padding: 6px 18px;
    border-color: #bcc4ca;
    &:hover {
      color: #2f3137;
      background-color: #f2f5f8;
      background-image: linear-gradient(180deg, #f2f5f8, #f2f5f8);
    }
  }
`;

export const FlameSecondaryButton = styled(Button)`
  &&& {
    background-image: linear-gradient(180deg, #537dec, #2e61de);
    color: white;
    padding: 6px 18px;
    border: 1px solid rgb(24, 68, 204);
    &:hover {
      background-color: rgb(46, 97, 222);
      background-image: linear-gradient(rgb(46, 97, 222), rgb(46, 97, 222));
    }
  }
`;

export const CustomModal = styled(Modal)`
  width: 600px;
  max-width: 600px;
  min-width: 600px;
`;
